import Model, { attr } from '@ember-data/model';

export default class BalanceAdjustmentModel extends Model {
  @attr('string') declare fundId: string;
  @attr('number') declare balance: number;
  @attr('number') declare adjustment: number;
  @attr('number') declare newBalance: number; // present if the user wants to update the final balance
  @attr('number') declare newAdjustment: number; // present if the user wants to update the adjustment

  get balanceWithoutAdjustment() {
    return this.balance - (this.adjustment || 0);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'admin/balance-adjustment': BalanceAdjustmentModel;
  }
}
